import React, { useEffect, useState } from 'react';
import Logo from './navbar/Logo';
import NavbarLinks from './navbar/NavbarLinks';
import Buscador from './navbar/Buscador';
import Carrito from './navbar/Carrito';
import { SlMagnifier } from "react-icons/sl";
import { FaShoppingCart, FaBars, FaTimes, FaArrowLeft } from "react-icons/fa";
import DatosTopNavbar from './navbar/DatosTopNavbar';
import RedesTopNavbar from './navbar/RedesTopNavbar';
import DolarOficial from './navbar/DolarOficial';
import Categorias from './navbar/Categorias';

function Navbar() {
  const [categoriaDesplegada, setCategoriaDesplegada] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [categoriaDesplegadaRes, setCategoriaDesplegadaRes] = useState(false);
  useEffect(() => {
    if (menuAbierto) {
      document.body.classList.add('overflow-hidden', 'h-screen');
    } else {
      document.body.classList.remove('overflow-hidden', 'h-screen');
    }
    
    // Limpieza en caso de desmontaje
    return () => document.body.classList.remove('overflow-hidden', 'h-screen');
  }, [menuAbierto]);
  
  return (
    <>
    <nav className='flex flex-col w-full shadow-navshadow relative'>
    {/* Navbar superior para datos y redes sociales */}
    <div className='hidden md:flex md:justify-end md:w-full md:h-6'>
    <DatosTopNavbar />
    <RedesTopNavbar iconStyle={'w-1/5 text-GrisOscuro'} size={18} extraStyle={'w-1/5 h-full lg:w-1/6 lg:justify-between'} />
    </div>
    
    {/* Navbar principal */}
    <div className='w-full flex justify-evenly items-center pt-5 p-2 mt-5'>
    {!menuAbierto && <Logo from='n' setCategoriaDesplegada={setCategoriaDesplegada} size={'w-60 xl:w-72'} />}
    
    <button className="flex md:hidden text-2xl" onClick={() => setMenuAbierto(!menuAbierto)}>
    {!menuAbierto && <FaBars />}
    </button>
    
    <div className='hidden md:flex w-full justify-around items-center '>
    <NavbarLinks setCategoriaDesplegada={setCategoriaDesplegada} categoriaDesplegada={categoriaDesplegada} />
    <Buscador setCategoriaDesplegada={setCategoriaDesplegada} item={<SlMagnifier size={20} />} />
    </div>
    </div>
    
    {/* Menú hamburguesa en dispositivos móviles */}
    <div
    className={` fixed w-2/3 top-0 left-0 h-full bg-white transition-transform duration-300 ease-in-out z-50 ${
    menuAbierto ? 'translate-x-0' : '-translate-x-full'
  } `}
      >
      <div className="flex flex-col items-start p-5 h-full overflow-y-auto">
      {/* Logo y botón de cerrar dentro del menú desplegable */}
      <div className="flex justify-evenly items-start w-full mb-5">
      <button onClick={() => setCategoriaDesplegadaRes(false)} className="text-xl text-Verde">
      <FaArrowLeft />
      </button>
      <Logo from='n' size={'w-60'} />
      <button onClick={() => setMenuAbierto(false)} className="text-xl text-Rojo">
      <FaTimes />
      </button>
      </div>
      <NavbarLinks setMenuAbierto={setMenuAbierto} setCategoriaDesplegadaRes={setCategoriaDesplegadaRes} setCategoriaDesplegada={setCategoriaDesplegada} categoriaDesplegada={categoriaDesplegada} menuAbierto={menuAbierto} />
      <div className='flex justify-between w-full p-3 items-center my-5'>
      <Carrito item={<FaShoppingCart size={25} />} />
      <DolarOficial menuAbierto={menuAbierto} />
      </div>
      <Buscador menuAbierto={menuAbierto} item={<SlMagnifier size={20} />} />
      </div>
      </div>
      
      {/* Navbar inferior para el dólar oficial y carrito */}
      {!menuAbierto && (
        <div className='flex justify-end items-center w-full p-2 space-x-4'>
        <DolarOficial />
        <Carrito item={<FaShoppingCart size={25} />} />
        </div>
      )}
      </nav>
      
      <Categorias
      setMenuAbierto={setMenuAbierto}
      categoriaDesplegadaRes={categoriaDesplegadaRes}
      setCategoriaDesplegadaRes={setCategoriaDesplegadaRes}
      menuAbierto={menuAbierto}
      categoriaDesplegada={categoriaDesplegada}
      setCategoriaDesplegada={setCategoriaDesplegada}
      />
      </>
    );
  }
  
  export default Navbar;
  